import { useQuery } from '@tanstack/react-query';
import { DatePicker, Divider, Form, Select, Table, TableProps, Tag } from 'antd';
import { useMedia } from 'hooks';
import { IKeys, IWork, IWorkState } from 'models';
import { workService } from 'services';
import { userStore } from 'stores';
import { getWorkNumber } from 'utils/get-work-number';

const { Item, useForm, useWatch } = Form;
const { Summary: { Cell, Row } } = Table;

export const SalesSalary = () => {
	const [form] = useForm();
	const author = useWatch('author', form);
	const dates = useWatch('dates', form);
	const { isMobile } = useMedia();

	const { data, isLoading } = useQuery({
		queryKey: [IKeys.WORKS, { author, state: IWorkState.COMPLETED, dates  }],
		queryFn: () => workService.getAll({ 
			author: [author], 
			per_page: 200,
			state: [IWorkState.COMPLETED],
			sortbydate: true,
			startd: dates[0].format('YYYY-MM-DD'),
			endd: dates[1].format('YYYY-MM-DD') }),
		enabled: !!author && Array.isArray(dates) && dates?.length === 2
	});

	const columns: TableProps<IWork>['columns'] = [{
		title: '№',
		dataIndex: ['id'],
		key: 'id',
		render: (_, record) => <Tag color="blue">{getWorkNumber(record)}</Tag>
	},{
		title: 'Total',
		dataIndex: ['acf', 'foreman_info', 'total'],
		key: 'date',
		render: val => `$${val}`
	}];

	return (
		<>
			<Form 
				form={form}
				layout="inline"
			>
				<Item name="author">
					<Select
						showSearch
						style={{ width: 300 }}
						placeholder="Enter name"
						size="large"
						options={userStore.managers.map(el => ({ value: el.id.toString(), label: el.name }))}
					/>
				</Item>
				<Item name="dates">
					<DatePicker.RangePicker
						size="large"
						format="MM/DD/YYYY"
						inputReadOnly
						className="completed-works"
						showTime
					/>
				</Item>
			</Form>

			<Divider />
			<div style={{
				paddingLeft: isMobile ? 45 : 0
			}}>
				<Table
					loading={isLoading}
					columns={columns}
					dataSource={data?.data}
					pagination={false}
					summary={pageData => {
						const res = pageData.reduce((acc, { acf: { foreman_info: { total  } } }) => {
							acc.total += Number(total);
							return acc;
						}, { total: 0 });
				
						return (
							<Row>
								<Cell index={0} />
								<Cell index={1}>{`$${res.total}`}</Cell>
							</Row>
						);
					}}
				/>
			</div>
		</>
	);
};

